module.exports = __webpack_public_path__ + "static/img/line_down_green.2476229d.png";